import React from "react"; // useEffect removed - was causing logo shift on navigation
import { useRive } from "@rive-app/react-canvas";

function LogoAnimation() {
    const { rive, RiveComponent } = useRive({
        src: "/animation/logo_icon_scaling.riv",
        stateMachines: "Logo_Icon Scalling",
        autoplay: true,
    });

    // Set canvas resolution for crisp rendering
    // NOTE: Commented out to prevent logo shifting on page navigation
    // This was causing layout reflow when switching pages
    // useEffect(() => {
    //     if (rive) {
    //         // Access the canvas through Rive's renderer
    //         const canvas = document.querySelector('canvas[data-rive-canvas]') ||
    //                       document.querySelector('canvas');
    //         if (canvas) {
    //             const dpr = window.devicePixelRatio || 1;
    //             const rect = canvas.getBoundingClientRect();
    //             if (rect.width && rect.height) {
    //                 canvas.width = rect.width * dpr;
    //                 canvas.height = rect.height * dpr;
    //                 const ctx = canvas.getContext('2d');
    //                 if (ctx) {
    //                     ctx.scale(dpr, dpr);
    //                 }
    //             }
    //         }
    //     }
    // }, [rive]);

    const handleMouseEnter = () => {
        if (rive) {
            const inputs = rive.stateMachineInputs("Logo_Icon Scalling");
            const hoverInput = inputs?.find(i => i.name === "Hover");
            if (hoverInput) hoverInput.value = true;
        }
    };

    const handleMouseLeave = () => {
        if (rive) {
            const inputs = rive.stateMachineInputs("Logo_Icon Scalling");
            const hoverInput = inputs?.find(i => i.name === "Hover");
            if (hoverInput) hoverInput.value = false;
        }
    };

    return (
        <RiveComponent
            style={{ width: 70, height: 120 }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        />
    );
}

export default LogoAnimation;
